import { AiOutlineFile } from "react-icons/ai";
import { IoIosLink } from "react-icons/io";
import { MdPause } from "react-icons/md";
import { VscHistory } from "react-icons/vsc";

import { ComponentWithAs, IconProps } from "@chakra-ui/react";

import { BuildSettingsIcon, SettingsToggleIcon, TemplateIcon } from "@/components/shared/ReleaseIcons";

export const applicationSettingsMenuItems = [
  { label: "General", icon: SettingsToggleIcon, slug: "" },
  "Templates",
  { label: "Application Template", icon: TemplateIcon, slug: "template" },
  { label: "Environment Variables", icon: TemplateIcon, slug: "environment_variables" },
  { label: "History", icon: VscHistory as ComponentWithAs<"svg", IconProps>, slug: "templates" },
  "Advanced",
  { label: "File Mounts", icon: AiOutlineFile as ComponentWithAs<"svg", IconProps>, slug: "file_mounts" },
  { label: "Primary Link", icon: IoIosLink as ComponentWithAs<"svg", IconProps>, slug: "primary_link" },
  { label: "Build Arguments", icon: BuildSettingsIcon, slug: "build_arguments" },
  { label: "Pausing Schedule", icon: MdPause as ComponentWithAs<"svg", IconProps>, slug: "pausing_schedule" },
] as const;

type ExtractSlug<T> = T extends { slug: infer S } ? S : never;
export type ApplicationSettingsMenuItem = ExtractSlug<(typeof applicationSettingsMenuItems)[number]>;
